/* istanbul ignore file */
import { UpdateForm } from 'framework/form';
import useSendEmailService from 'infrastructure/email/sendEmail/sendEmailService';
import SendEmailForm from 'infrastructure/email/sendEmail/createupdate/SendEmailForm';
import { useSendEmailUrl, useSendEmailId } from 'infrastructure/email/sendEmail/sendEmailRouting';
import UpdateSendEmailPageLayout from 'infrastructure/email/sendEmail/createupdate/Update/UpdateSendEmailPageLayout';

const UpdateSendEmail = () => {
  const { getData, updateData, getValidationSchema } = useSendEmailService();
  const emailId = useSendEmailId();
  const { getSingleEntityUrl } = useSendEmailUrl();

  return (
    <UpdateForm
      submitFormFunc={updateData}
      getDataFunc={getData}
      entityId={emailId}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Email has been successfully updated.',
      }}
    >
      <UpdateSendEmailPageLayout>
        <SendEmailForm />
      </UpdateSendEmailPageLayout>
    </UpdateForm>
  );
};

export default UpdateSendEmail;
